"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornApplication = void 0;
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var AcornFeatureContainer_1 = require("./AcornFeatureContainer");
var AcornApplication = function (props) {
    return (react_1.default.createElement(morse_react_1.PortalContainer, null,
        react_1.default.createElement(AcornFeatureContainer_1.AcornFeatureContainer, null, props.children)));
};
exports.AcornApplication = AcornApplication;
//# sourceMappingURL=AcornApplication.js.map